import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faEnvelope } from '@fortawesome/free-solid-svg-icons';

const AdminLoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  // Verificar si ya está autenticado
  useEffect(() => {
    const token = localStorage.getItem('admin_token');
    const email = localStorage.getItem('admin_email');

    if (token && email) {
      navigate('/admin', { replace: true });
    }
  }, [navigate]);

  // Credenciales válidas (las mismas que en Header.jsx)
  const validCredentials = {
    'eugenio@packsys.com': {
      name: 'Eugenio',
      password: 'unete-eugenio-admin_2026$',
      role: 'super_admin',
    },
    'talento01@packsys.com': {
      name: 'Diana',
      password: 'unete-diana-admin_2026$',
      role: 'admin',
    },
    'karen@packsys.com': {
      name: 'Karen',
      password: 'unete-karen-admin_2026$',
      role: 'admin',
    },
    'talento08@packsys.com': {
      name: 'Michelle',
      password: 'unete-michelle-admin_2026$',
      role: 'admin',
    },
    'monse@packsys.com': {
      name: 'Monse',
      password: 'unete-monse-admin_2026$',
      role: 'admin',
    },
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // Verifica si el usuario existe y la contraseña es correcta
      if (
        validCredentials[email] &&
        validCredentials[email].password === password
      ) {
        // Generar token simulado
        const token = btoa(`${email}:${Date.now()}`);
        localStorage.setItem('admin_token', token);
        localStorage.setItem('admin_email', email);
        localStorage.setItem('admin_name', validCredentials[email].name);

        // Disparar evento personalizado para actualizar Header
        window.dispatchEvent(new Event('storage'));
        window.dispatchEvent(new Event('authChange'));

        // Redirigir al panel de administración
        navigate('/admin');
      } else {
        setError(
          'Credenciales incorrectas. Por favor, verifica tu correo y contraseña.'
        );
      }
    } catch (err) {
      setError('Error al iniciar sesión. Por favor, intenta nuevamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white pt-16">
      <div className="container mx-auto px-4 py-4">
        <div className="max-w-md mx-auto">
          {/* Logo y encabezado */}
          <div className="text-center mb-10">
            <h1 className="text-3xl font-bold text-gray-900 mb-3">
              Acceso al Panel de Administración
            </h1>
            <p className="text-gray-600">
              Ingresa tus credenciales para acceder al sistema
            </p>
          </div>

          {/* Formulario de login */}
          <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
            <div className="p-8">
              <form onSubmit={handleLogin} className="relative space-y-6">
                {/* Campo Email */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    <div className="flex items-center">
                      <FontAwesomeIcon
                        icon={faEnvelope}
                        className="w-4 h-4 mr-2 text-gray-400"
                      />
                      Correo electrónico
                    </div>
                  </label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-orange focus:border-transparent transition-all"
                    placeholder="admin@packsys.com"
                    required
                  />
                </div>

                {/* Campo Contraseña */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    <div className="flex items-center">
                      <FontAwesomeIcon
                        icon={faLock}
                        className="w-4 h-4 mr-2 text-gray-400"
                      />
                      Contraseña
                    </div>
                  </label>
                  <div className="relative">
                    <input
                      type={showPassword ? 'text' : 'password'}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-orange focus:border-transparent transition-all pr-12"
                      placeholder="••••••••••••••••"
                      required
                    />

                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                    >
                      {showPassword ? (
                        <svg
                          className="w-5 h-5"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L6.59 6.59m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                          />
                        </svg>
                      ) : (
                        <svg
                          className="w-5 h-5"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                          />
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                          />
                        </svg>
                      )}
                    </button>
                  </div>
                </div>

                {/* Mensaje de error */}
                {error && (
                  <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
                    <div className="flex items-center">
                      <svg
                        className="w-5 h-5 text-red-500 mr-3"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                      <span className="text-red-600 text-sm">{error}</span>
                    </div>
                  </div>
                )}

                {/* Botones */}
                <div className="space-y-4">
                  <button
                    type="submit"
                    disabled={loading}
                    className="w-full btn-primary bg-gradient-to-r from-red-500 via-orange-500 to-yellow-500 py-3 text-lg font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {loading ? (
                      <span className="flex items-center justify-center">
                        <svg
                          className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          />
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          />
                        </svg>
                        Verificando...
                      </span>
                    ) : (
                      'Iniciar Sesión'
                    )}
                  </button>

                  <Link
                    to="/"
                    className="block w-full py-3 text-gray-600 hover:text-gray-900 font-medium rounded-lg border border-gray-300 hover:border-gray-400 transition-colors text-center"
                  >
                    Volver al inicio
                  </Link>
                </div>

                {/* Información adicional */}
                <div className="pt-6 border-t border-gray-200">
                  <p className="text-sm text-gray-500 text-center">
                    Usa las credenciales proporcionadas por el administrador del
                    sistema
                  </p>
                </div>
              </form>
            </div>
          </div>

          {/* Enlace de ayuda */}
          <div className="mt-8 text-center">
            <p className="text-gray-500 text-sm">
              ¿Problemas para acceder?{' '}
              <a
                href="mailto:eugenio@packsys.com"
                className="text-primary-blue hover:text-primary-orange font-medium"
              >
                Contacta al administrador
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLoginPage;
